"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Dialogue = function Dialogue(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M12.003 18.881a7.987 7.987 0 01-1.466-.155.808.808 0 00-.642.166 6.59 6.59 0 01-3.142 1.235.34.34 0 01-.318-.53c.44-.547.755-1.184.925-1.865a.504.504 0 00-.188-.49 6.612 6.612 0 01-2.669-5.236c0-3.792 3.358-6.875 7.5-6.875 4.142 0 7.5 3.083 7.5 6.876 0 3.792-3.358 6.874-7.5 6.874zm0-2.5a.937.937 0 100-1.874.937.937 0 000 1.874zm0-8.75c-1.38 0-2.5.98-2.5 2.188-.002.24.028.478.09.709.038.135.162.229.303.229h.635a.311.311 0 00.293-.414 1.604 1.604 0 01-.08-.524c0-.518.596-.938 1.2-.938.605 0 1.192.42 1.192.938 0 1.557-1.758 1.361-1.758 3.438 0 .172.14.312.312.312h.704c.172 0 .312-.14.312-.313 0-1.51 1.797-1.432 1.797-3.437 0-1.208-1.119-2.188-2.5-2.188z"
  }));
};

var _default = (0, _react.forwardRef)(Dialogue);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Dialogue, "Dialogue", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Dialogue.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Dialogue.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9EaWFsb2d1ZS50c3giXSwibmFtZXMiOlsiRGlhbG9ndWUiLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsUUFBd0UsR0FBRyxTQUEzRUEsUUFBMkUsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSO0FBQUEsU0FDL0U7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9ERCxLQUFwRDtBQUEyRCxJQUFBLEdBQUcsRUFBRUM7QUFBaEUsTUFDRTtBQUNFLElBQUEsSUFBSSxFQUFDLGNBRFA7QUFFRSxJQUFBLENBQUMsRUFBQztBQUZKLElBREYsQ0FEK0U7QUFBQSxDQUFqRjs7ZUFTZSx1QkFBV0YsUUFBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxRIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBEaWFsb2d1ZTogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTIuMDAzIDE4Ljg4MWE3Ljk4NyA3Ljk4NyAwIDAxLTEuNDY2LS4xNTUuODA4LjgwOCAwIDAwLS42NDIuMTY2IDYuNTkgNi41OSAwIDAxLTMuMTQyIDEuMjM1LjM0LjM0IDAgMDEtLjMxOC0uNTNjLjQ0LS41NDcuNzU1LTEuMTg0LjkyNS0xLjg2NWEuNTA0LjUwNCAwIDAwLS4xODgtLjQ5IDYuNjEyIDYuNjEyIDAgMDEtMi42NjktNS4yMzZjMC0zLjc5MiAzLjM1OC02Ljg3NSA3LjUtNi44NzUgNC4xNDIgMCA3LjUgMy4wODMgNy41IDYuODc2IDAgMy43OTItMy4zNTggNi44NzQtNy41IDYuODc0em0wLTIuNWEuOTM3LjkzNyAwIDEwMC0xLjg3NC45MzcuOTM3IDAgMDAwIDEuODc0em0wLTguNzVjLTEuMzggMC0yLjUuOTgtMi41IDIuMTg4LS4wMDIuMjQuMDI4LjQ3OC4wOS43MDkuMDM4LjEzNS4xNjIuMjI5LjMwMy4yMjloLjYzNWEuMzExLjMxMSAwIDAwLjI5My0uNDE0IDEuNjA0IDEuNjA0IDAgMDEtLjA4LS41MjRjMC0uNTE4LjU5Ni0uOTM4IDEuMi0uOTM4LjYwNSAwIDEuMTkyLjQyIDEuMTkyLjkzOCAwIDEuNTU3LTEuNzU4IDEuMzYxLTEuNzU4IDMuNDM4IDAgLjE3Mi4xNC4zMTIuMzEyLjMxMmguNzA0Yy4xNzIgMCAuMzEyLS4xNC4zMTItLjMxMyAwLTEuNTEgMS43OTctMS40MzIgMS43OTctMy40MzcgMC0xLjIwOC0xLjExOS0yLjE4OC0yLjUtMi4xODh6XCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoRGlhbG9ndWUpO1xuIl19